import { excuseApi } from '../commons/http';

export const getDevTickets = async (params) => {
  const res = await excuseApi({
    path: '/dev-tickets',
    method: 'GET',
    params,
  });
  return res.data;
};

export const getDevTicket = async (id) => {
  const res = await excuseApi({
    path: `/dev-tickets/${id}`,
    method: 'GET',
  });
  return res.data;
};

export const createDevTicket = async (data) => {
  const res = await excuseApi({
    path: '/dev-tickets',
    method: 'POST',
    body: data,
  });
  return res.data;
};

export const updateDevTicket = async (id, data) => {
  const res = await excuseApi({
    path: `/dev-tickets/${id}`,
    method: 'PATCH',
    body: data,
  });
  return res.data;
};

export const deleteDevTicket = async (id) => {
  const res = await excuseApi({
    path: `/dev-tickets/${id}`,
    method: 'DELETE',
  });
  return res.data;
};

export const updateDevTicketStatus = async (id, status) => {
  const res = await excuseApi({
    path: `/dev-tickets/${id}/status`,
    method: 'PATCH',
    body: { status },
  });
  return res.data;
};

export const addDevTicketComment = async (id, body) => {
  const res = await excuseApi({
    path: `/dev-tickets/${id}/comments`,
    method: 'POST',
    body: { body },
  });
  return res.data;
};

export const addDevTicketImage = async (id, image_url) => {
  const res = await excuseApi({
    path: `/dev-tickets/${id}/images`,
    method: 'POST',
    body: { image_url },
  });
  return res.data;
};
